import type { Bank } from '../types';

export function InfoBar({ bank }: { bank: Bank }) {
  const byType = bank.by_type || {};
  const count = (t: string) =>
    byType[t as 'single' | 'multiple' | 'blank'] ||
    bank.questions.filter(q => q.type === t).length;

  return (
    <div className="info-bar">
      <div>
        <div className="subject">{bank.subject || '未命名题库'}</div>
        <div className="stat">{bank.source ? '来源：' + bank.source : ''}</div>
      </div>
      <div className="stat">题目总数 <b>{bank.questions.length}</b></div>
      <div className="stat">单选 <b>{count('single')}</b></div>
      <div className="stat">多选 <b>{count('multiple')}</b></div>
      <div className="stat">填空 <b>{count('blank')}</b></div>
    </div>
  );
}
